import { ComponentProps, JSX } from "solid-js";
import c from "class-c";

import Icon from "@repo/utils/Icon";

import Card from "../containers/Card";

declare namespace Alert {
  type Type = "error" | "warning" | "info" | "discount";
  type Props = Card.Props & {
    class?: string;
    type: Type;
    icon?: Icon;
    propsFor?: {
      icon?: ComponentProps<"div">;
    };
    variant?: "outlined" | "color-on-dugout";
    children: JSX.Element;
  };
}

function Alert({
  class: className,
  type,
  variant = "outlined",
  icon = Alert.iconByType[type],
  propsFor = {},
  children,
  ...props
}: D<Alert.Props>) {
  const baseColor = () => (type === "info" ? "strong" : type);

  return (
    <Card
      class={c`
        row
        ${
          variant === "color-on-dugout" &&
          `color:${baseColor()} bg:${baseColor()}-dugout`
        }
        ${className}
      `}
      outline={
        variant === "outlined" && (type === "info" ? true : `var(--${type})`)
      }
      {...props}
    >
      <div
        {...propsFor.icon}
        class={c`mr-1.5 color:${baseColor()} ${propsFor.icon?.class}`}
      >
        {icon}
      </div>
      <div class="expand">{children}</div>
    </Card>
  );
}

Alert.iconByType = {
  error: "",
  warning: "",
  info: "",
  discount: "",
} satisfies Record<Alert.Props["type"], Icon>;

export default Alert;
